import { render, staticRenderFns } from "./DataListTable.vue?vue&type=template&id=70e35fde&"
import script from "./DataListTable.vue?vue&type=script&lang=js&"
export * from "./DataListTable.vue?vue&type=script&lang=js&"
import style0 from "./DataListTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports